import { get } from './generic.api';

export const fetchClientsDetails = async () => {
  try {
    return await get(`/clients/intranet/client/me/`);
  } catch (error) {
    console.error('Erro ao carregar detalhes do cliente:', error.response || error);
    throw error;
  }
};